import {Component, forwardRef, Inject, Injector, OnInit} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ClientService} from '../../services/client.service';
import {AlertService} from '../../services/alert.service';
import {SessionService} from '../../services/session.service';
import {TranslateService} from '@ngx-translate/core';
import {EmployeeTimesheetLine} from '../../model/EmployeeTimesheetLine';
import {ValidationResult} from '../../model/Errors';

import {MaskFormats} from "../../model/common.model";
import {EmployeeHoraire} from "../../model/EmployeHoraire";
import {Utils} from "../../model/Utils";

@Component({
  templateUrl: './WorkedHoursTimesheetComponent.html'
})

export class WorkedHoursTimesheetComponent implements OnInit {

  line: EmployeeTimesheetLine;

  currentEmployeeHoraire: EmployeeHoraire;

  workedHoursValidation = new ValidationResult();

  editMode = false;
  hourMinuteMask = MaskFormats.HOUR_FORMAT_24_ANY_MINUTES;
  realShiftStartText: string;
  realShiftEndText: string;
  private _AMPMFormat = false;

  constructor (private injector: Injector,
               private modalService: NgbModal,
               @Inject(forwardRef(() => ClientService)) private clientService: ClientService,
               private alertService: AlertService,
               @Inject(forwardRef(() => SessionService)) private session: SessionService,
               private translate: TranslateService) {
    this.line = this.injector.get('line');
    this.currentEmployeeHoraire = this.line.retrieveCurrentEmployeeHoraire();


    if (this.session.userInfo.isAMPM()){
      this.hourMinuteMask = MaskFormats.HOUR_FORMAT_AM_PM_ANY_MINUTES;
      this._AMPMFormat = true;
      //console.log('AMPM is on! ' + this.hourMinuteMask);
    }


  }

  enterEditMode(){
    this.editMode = false;
    /*
    const userPref = this.session.userInfo.getPref(PrefName.USE_ALTERNATE_UI);
    if (userPref!=null){
      if (userPref.asBoolean()) {
        if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.sdStartDt)){
          this.realShiftStartText = this.session.formatDateAsHour(this.currentEmployeeHoraire.sdStartDt);
        }
        if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.sdEndDt)){
          this.realShiftEndText = this.session.formatDateAsHour(this.currentEmployeeHoraire.sdEndDt);
        }
        this.editMode = true;
      }
    }
    */

  }

  onChange($event) {
    console.log('onChange');

    this.currentEmployeeHoraire.adjustTimesheetStartAndEndHours(this.realShiftStartText,this.realShiftEndText,this._AMPMFormat);

    // this.validate();
    // this.calculateWorkedHours();

  }


  ngOnInit(): void {
//    console.log('WorkedHoursTimesheetComponent:init aka validateWorkedHours. ' + JSON.stringify(this.currentEmployeeHoraire,null,1));


    this.line.getMessage().subscribe((msg)=>{
        // Message received.
      console.log('Received Message: ' + msg);
        this._validate();
    });

    this._validate();

    // const workedHoursStartValidation = this.line.validateWorkedHoursStart(this.translate, this.clientService);
    // const workedHoursEndValidation = this.line.validateWorkedHoursEnd(this.translate, this.clientService);


    // this.workedHoursValidation = this.line.validateWorkedHours(this.translate, this.clientService);
  }

  private _validate(){
    this.line.validateWorkedHours(this.translate, this.clientService,this.session).subscribe((workedHoursCommonValidation)=>{
      this.workedHoursValidation = new ValidationResult();
      // this.workedHoursValidation.append(workedHoursCommonValidation).append(workedHoursStartValidation).append(workedHoursEndValidation);
      this.workedHoursValidation.append(workedHoursCommonValidation);
    });

  }

  public hasErrors(): boolean{
    if (this.isPaid()){
      if (this.needToSpecifyHours()){
        if (!this.workedHoursValidation.isSuccess()){
          return true;
        }else{
          // console.log(this.currentEmployeeHoraire.id + ' '+ this.currentEmployeeHoraire.tsType +  ': has no errors.');
        }
      }else{
        // console.log(this.currentEmployeeHoraire.id + ' '+ this.currentEmployeeHoraire.tsType +  ': Does not need to specify hours');
      }
    }else{
      // console.log(this.currentEmployeeHoraire.id + ' '+ this.currentEmployeeHoraire.tsType +  ': Not Paid');
    }
    return false;
    // !workedHoursValidation.isSuccess() && isPaid() && needToSpecifyHours()
  }


  public isPaid():boolean{
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsType)){
      return this.currentEmployeeHoraire.tsType.paid;
    }
    return true;
  }

  public needToSpecifyHours():boolean{
    let res = true;
    if (!Utils.isNullOrUndefined(this.currentEmployeeHoraire.tsType)){
      res = this.currentEmployeeHoraire.tsType.needsToSpecifyHours();
    }
    if (!res){
      this.workedHoursValidation.applyStyle = false;
    }

    return res;
  }

  public hasInfo(): boolean{
    if (!this.hasScheduledInfo()) {
      if (!this.hasPunchedInfo()) {
         return false;
      }
    }
    return true;
  }

  public hasScheduledInfo(): boolean {
    if (!this.currentEmployeeHoraire.sdStartDt) {
      if (!this.currentEmployeeHoraire.sdEndDt) {
        return false;
      }
    }
    return true;
  }

  public hasPunchedInfo(): boolean {
    if (!this.currentEmployeeHoraire.tsStartPunchDt) {
      if (!this.currentEmployeeHoraire.tsEndPunchDt) {
        return false;
      }
    }
    return true;
  }

}
